var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79c7281a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-setting-form__scrollable-section" };
const _hoisted_2 = { class: "top-toolbar__group" };
const _hoisted_3 = { class: "top-toolbar__group" };
const _hoisted_4 = { class: "top-toolbar__group__left" };
const _hoisted_5 = {
    key: 1,
    class: "inline-divider"
};
const _hoisted_6 = {
    key: 0,
    class: "top-toolbar__group"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "inline-divider" }, "|", -1 /* HOISTED */));
const _hoisted_8 = {
    key: 0,
    class: "component-setting-form__description-input"
};
const _hoisted_9 = {
    key: 1,
    class: "top-toolbar__group search-bar__group"
};
const _hoisted_10 = { class: "top-toolbar__group" };
const _hoisted_11 = { class: "search-bar-container" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "inline-divider" }, "|", -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "inline-divider" }, "|", -1 /* HOISTED */));
const _hoisted_14 = { class: "component-setting-form__footer text-right" };
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import ComponentVariableList from "src/shared/v-components/component-variable/list/ComponentVariableList.vue";
import Button from "src/shared/v-components/ui/Button.vue";
import { computed } from "vue";
import { useCampaignFrontendAssets } from "src/shared/store/campaign-built/composables/useCampaignFrontendAssets";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
import { useComponentMutableStateStore } from "src/shared/v-components/component-variable/item/component-variable-state";
import { saveComponent } from "src/shared/store/component/service/saveComponent";
import ComponentVariableToolbarFilterMenu from "src/shared/v-components/component-variable/toolbar/ComponentVariableToolbarFilterMenu.vue";
import Session from "Session";
import ComponentVariableToolbarKebabMenu from "src/shared/v-components/component-variable/toolbar/ComponentVariableToolbarKebabMenu.vue";
import { useComponentDisplayNameMutable } from "src/shared/v-components/component/display-name/useComponentDisplayNameMutable";
import ComponentDisplayNameInput from "src/shared/v-components/component/display-name/ComponentDisplayNameInput.vue";
import notificationService from "src/shared/notification/notification-service";
import ComponentVariableToolbarEnabledSwitch from "src/shared/v-components/component-variable/toolbar/ComponentVariableToolbarEnabledSwitch.vue";
import SearchBar from "src/shared/v-components/ui/search/SearchBar.vue";
import { useComponentVariableMutableFilter } from "src/shared/store/component-variable-mutable/composables/useComponentVariableMutableSetFilter";
import ComponentDescriptionInput from "src/shared/v-components/component/component-drawer/component-description/ComponentDescriptionInput.vue";
import { useComponentDescriptionMutable } from "../../component/component-drawer/component-description/useComponentDescriptionMutable";
const INCLUDE_SEARCH_BAR_THRESHOLD = 10;
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentSettingForm',
    props: {
        componentMutableKey: {},
        componentDrawerRouteConfig: {}
    },
    setup(__props) {
        const props = __props;
        const isSuperUser = Session.getInstance().isSuperUser();
        const componentMutableStateStore = useComponentMutableStateStore();
        const { componentMutable } = useComponentMutable(computed(() => props.componentMutableKey));
        const componentId = computed(() => { var _a; return (_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.component_id; });
        const { builtComponent } = useBuiltComponent(componentId);
        const campaignId = computed(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.campaign_id; });
        const settingCount = computed(() => {
            var _a, _b;
            return (_b = (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.listSettings().length) !== null && _b !== void 0 ? _b : 0;
        });
        const { campaignFrontendAssets } = useCampaignFrontendAssets(campaignId);
        const campaignFrontendAsset = computed(() => {
            return campaignFrontendAssets.value.find((asset) => asset.getComponentId() === componentId.value);
        });
        const includeSearchBar = computed(() => {
            return (settingCount.value >= INCLUDE_SEARCH_BAR_THRESHOLD ||
                !!campaignFrontendAsset.value);
        });
        const { componentVariableMutableFilter } = useComponentVariableMutableFilter(props.componentMutableKey);
        const search = computed({
            get() {
                if (!componentVariableMutableFilter.value) {
                    return "";
                }
                return componentVariableMutableFilter.value.search;
            },
            set(value) {
                if (!componentVariableMutableFilter.value) {
                    return;
                }
                componentVariableMutableFilter.value.search = value;
            },
        });
        const { displayName } = useComponentDisplayNameMutable(componentMutable);
        const { description } = useComponentDescriptionMutable(componentMutable);
        const isDirty = computed(() => {
            if (!componentMutable.value) {
                return false;
            }
            return componentMutable.value.isDirty();
        });
        const isLoading = computed(() => {
            if (!componentMutable.value) {
                return false;
            }
            return componentMutableStateStore.isLoading(componentMutable.value.componentMutableKey);
        });
        const applyChanges = () => __awaiter(this, void 0, void 0, function* () {
            if (!componentMutable.value) {
                return;
            }
            yield saveComponent(componentMutable.value);
            notificationService.success("Changes applied successfully");
        });
        return (_ctx, _cache) => {
            return (_ctx.componentMutableKey)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["component-setting-form", {
                            'component-setting-form--with-search-bar': includeSearchBar.value,
                        }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        (_unref(builtComponent))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["top-toolbar", {
                                        'top-toolbar--with-search-bar': includeSearchBar.value,
                                    }])
                            }, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(ComponentDisplayNameInput, {
                                                displayName: _unref(displayName),
                                                "onUpdate:displayName": _cache[0] || (_cache[0] = ($event) => (_isRef(displayName) ? (displayName).value = $event : null)),
                                                placeholder: _unref(builtComponent).getDisplayName()
                                            }, null, 8 /* PROPS */, ["displayName", "placeholder"])
                                        ]),
                                        (_unref(builtComponent).isEnableable())
                                            ? (_openBlock(), _createBlock(ComponentVariableToolbarEnabledSwitch, {
                                                key: 0,
                                                "component-mutable-key": _ctx.componentMutableKey
                                            }, null, 8 /* PROPS */, ["component-mutable-key"]))
                                            : _createCommentVNode("v-if", true),
                                        (_unref(builtComponent).isEnableable() &&
                                            !includeSearchBar.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "|"))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    (!includeSearchBar.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(ComponentVariableToolbarFilterMenu, { "component-mutable-key": _ctx.componentMutableKey }, null, 8 /* PROPS */, ["component-mutable-key"]),
                                            (_unref(isSuperUser) && componentId.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _hoisted_7,
                                                    _createVNode(ComponentVariableToolbarKebabMenu, { "component-id": componentId.value }, null, 8 /* PROPS */, ["component-id"])
                                                ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true)
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                (_unref(builtComponent))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createVNode(ComponentDescriptionInput, {
                                            description: _unref(description),
                                            "onUpdate:description": _cache[1] || (_cache[1] = ($event) => (_isRef(description) ? (description).value = $event : null)),
                                            placeholder: _unref(builtComponent).getDescription()
                                        }, null, 8 /* PROPS */, ["description", "placeholder"])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                (includeSearchBar.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createVNode(SearchBar, {
                                                    placeholder: "Search",
                                                    search: search.value,
                                                    "onUpdate:search": _cache[2] || (_cache[2] = ($event) => ((search).value = $event))
                                                }, null, 8 /* PROPS */, ["search"])
                                            ]),
                                            _hoisted_12,
                                            _createVNode(ComponentVariableToolbarFilterMenu, { "component-mutable-key": _ctx.componentMutableKey }, null, 8 /* PROPS */, ["component-mutable-key"]),
                                            (_unref(isSuperUser) && componentId.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _hoisted_13,
                                                    _createVNode(ComponentVariableToolbarKebabMenu, { "component-id": componentId.value }, null, 8 /* PROPS */, ["component-id"])
                                                ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true),
                        _createVNode(ComponentVariableList, {
                            class: "component-setting-form__variable-list",
                            "component-mutable-key": _ctx.componentMutableKey,
                            type: 'STANDARD',
                            componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                        }, null, 8 /* PROPS */, ["component-mutable-key", "componentDrawerRouteConfig"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(Button, {
                            "is-disabled": !isDirty.value,
                            "is-pending": isLoading.value,
                            onClick: applyChanges
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Apply ")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["is-disabled", "is-pending"])
                    ])
                ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
